export default __webpack_public_path__ + "static/media/FARM.67306164.png";